import React from "react";

const Services = () => {
  return <>Services page</>;
};

export { Services };
